import seamlessPipes from '../Assets/HomeAssets/seemlessPipes.jpg'
import seamlessTubes from '../Assets/HomeAssets/seemlessTubes.jpg'
import weldFittings from '../Assets/HomeAssets/bends.jpg'
import steelFittings from '../Assets/HomeAssets/fittness.jpg'
import flangs from '../Assets/HomeAssets/flangs.jpg'
import valves from '../Assets/HomeAssets/valves.jpg'
import pump from '../Assets/HomeAssets/pump.JPG'

const SliderData = [

    {
        id: 1,
        title: "SEAMLESS PIPES",
        image: <img src={seamlessPipes} alt='Product' />,
        text: "WE PROVIDE THE BEST SEAMLESS PIPES TO OUR CUSTOMERS."
    },
    {
        id: 2,
        title: "SEAMLESS TUBES",
        image: <img src={seamlessTubes} alt='Product' />,
        text: "WE PROVIDE THE BEST SEAMLESS TUBES TO OUR CUSTOMERS."
    },
    {
        id: 3,
        title: "BUTT WELD FITTINGS",
        image: <img src={weldFittings} alt='Product' />,
        text: "WE PROVIDE THE BEST BUTT WELD FITTINGS TO OUR CUSTOMERS."
    },
    {
        id: 4,
        title: "FORGED STEEL FITTINGS",
        image: <img src={steelFittings} alt='Product' />,
        text: "WE PROVIDE THE BEST FORGED STEEL FITTINGS TO OUR CUSTOMERS."
    },
    {
        id: 5,
        title: "FLANGES",
        image: <img src={flangs} alt='Product' />,
        text: "WE PROVIDE THE BEST FLANGES TO OUR CUSTOMERS."
    },
    {
        id: 6,
        title: "VALVES",
        image: <img src={valves} alt='Product' />,
        text: "WE PROVIDE THE BEST VALVES TO OUR CUSTOMERS."
    },
    {
        id: 7,
        title: "PUMPS",
        image: <img src={pump} alt='Product' />,
        text: "WE PROVIDE THE BEST PUMPS TO OUR CUSTOMERS."
    },
]

export default SliderData